<div class="side-panel-right">
  @if (tab === 'notifications') {
    <div>
      <notifications
        (sidePanelRightClose)="onSidePanelRightClose()"
      ></notifications>
    </div>
  }
  @if (tab === 'assign') {
    <div
      class="assign-panel-container"
        [ngClass]="{
            'assign-panel-container-with-builder' : creatingLesson || creatingActivity
        }"
      >
      @if (creatingLesson || creatingActivity) {
        <assign-cart-content-builder
          class="content-builder"
          [assignCartOpen]="assignCartOpen"
          [creatingLesson]="creatingLesson"
          [creatingActivity]="creatingActivity"
          (sidePanelRightClose)="onSidePanelRightClose()"
        ></assign-cart-content-builder>
      }
      <assign-cart-side-panel
        [assignCartOpen]="assignCartOpen"
        (sidePanelRightClose)="onSidePanelRightClose()"
      ></assign-cart-side-panel>
    </div>
  }
</div>
